import {Button, ButtonSize, ButtonType, Modal} from "@renta-apps/renta-react-components";
import styles from './GetReportModal.module.scss';
import {ProductWithTelematics} from "@/models/server/Models/Equipment/ProductWithTelematics";
import {ConstructionSiteModel} from "@/models/server/ConstructionSiteModel";
import Localizer from "@/localization/Localizer";
import {downloadCsvReport} from "@/services/ConstructionSiteService";
import React from "react";

interface IGetReportDownloadSectionProps {
    products: ProductWithTelematics[];
    constructionSite: ConstructionSiteModel | null;
    modalRef: React.RefObject<Modal>;
}

const GetReportDownloadSection: React.FC<IGetReportDownloadSectionProps> = ({products, constructionSite, modalRef}) => {
    const handleDownload = async (products: ProductWithTelematics[]): Promise<void> => {
        await downloadCsvReport(
            products.map(x => ({
                internalId: x.internalId,
                rentaId: x.rentaId,
                constructionSiteId: constructionSite?.id ?? ""
            })),
            constructionSite?.name ?? "",
            constructionSite?.ownerName ?? "",
            constructionSite?.id ?? ""
        );

        await modalRef.current?.closeAsync();
    };

    return (
        <div className={styles.downloadSection}>
            <div className={styles.downloadSectionText}>
                <div className={styles.primaryText}>
                    {Localizer.constructionSiteDetailsEquipmentTabGetReportModalDownloadTitle}
                </div>
                <div className={styles.secondaryText}>
                    {Localizer.constructionSiteDetailsEquipmentTabGetReportModalDownloadText}
                </div>
            </div>
            <div className={styles.buttonContainer}>
                <Button
                    type={ButtonType.Primary}
                    size={ButtonSize.Small}
                    id={"downloadCsvButton"}
                    className={styles.downloadButton}
                    onClick={async () => {
                        await handleDownload(products);
                    }}
                >
                    {Localizer.constructionSiteDetailsEquipmentTabGetReportModalDownloadSectionButtonText}
                </Button>
            </div>
        </div>
    );
};

export default GetReportDownloadSection;